import { StateCreator } from 'zustand'

import { Authorization } from '../types'

interface ApplicationState {
  authorization: Authorization | null
}

interface ApplicationActions {
  setAuthorization: (user: Authorization | null) => void
}

export type ApplicationSlice = ApplicationState & ApplicationActions

export const initialApplicationState: ApplicationState = {
  authorization: null,
}

const createApplicationSlice: StateCreator<ApplicationSlice, [], [], ApplicationSlice> = (set) => ({
  ...initialApplicationState,
  setAuthorization: (authorization) => set({ authorization }),
})

export default createApplicationSlice
